export default __webpack_public_path__ + "static/media/X500.2e646037.jpg";